import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "panel"
    }}>{`Panel`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`It uses the AppLayout`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`It expects 3 direct children (PanelHeader, PanelContent, PanelFooter)`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`<Panel>
  <PanelHeader />
  <PanelContent />
  <PanelFooter />
</Panel>
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Panel will pass a onClose prop to it's children`}</p>
        <p parentName="li">{`but allow final user overwrite, this is nice if
you want a different behaviour for the button
that is automatically added to the PanelFooter`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "panelheader"
    }}>{`PanelHeader`}</h3>
    <ul>
      <li parentName="ul">{`has a background color of `}<inlineCode parentName="li">{`theme.primary.main`}</inlineCode></li>
      <li parentName="ul">{`has a font color of `}<inlineCode parentName="li">{`theme.primary.pureWhite`}</inlineCode></li>
      <li parentName="ul">{`display a close icon in the upper right`}</li>
      <li parentName="ul">{`props:`}<ul parentName="li">
          <li parentName="ul">{`required`}<ul parentName="li">
              <li parentName="ul">{`title`}</li>
              <li parentName="ul">{`hasClose (should default to true => TODO)`}</li>
            </ul></li>
          <li parentName="ul">{`optional`}<ul parentName="li">
              <li parentName="ul">{`onClose`}</li>
            </ul></li>
        </ul></li>
    </ul>
    <h3 {...{
      "id": "panelcontent"
    }}>{`PanelContent`}</h3>
    <p>{`props:`}</p>
    <h3 {...{
      "id": "panelfooter"
    }}>{`PanelFooter`}</h3>
    <ul>
      <li parentName="ul">{`has a background color of `}<inlineCode parentName="li">{`theme.primary.white`}</inlineCode></li>
      <li parentName="ul">{`display a button icon in the upper right`}</li>
      <li parentName="ul">{`props:`}<ul parentName="li">
          <li parentName="ul">{`cancelLabel`}</li>
          <li parentName="ul">{`hasCancel (should default to true => TODO)`}</li>
        </ul></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      